import { render } from "./FormsLayout.vue?vue&type=template&id=e72decd2"
import script from "./FormsLayout.vue?vue&type=script&lang=js"
export * from "./FormsLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__